import { EnvironmentType } from 'src/environments/schema/environment.enum';
import { createEnvironment } from 'src/environments/presets/environment.factory';

export const environment = createEnvironment(EnvironmentType.LIVE, {
  production: true
});